export default __webpack_public_path__ + "static/media/enable_leaderboard.847a49c9.svg";